import React from "react";
import styled from "styled-components";

const HeaderContainer = styled.div`
        
    @media(max-width:768px){
        padding-left:10px !important;
        padding-right:10px !important;
    }

`;
export interface IClosingHeaderProps {
    className?: string,
    headerText: any,
    label?: string
}

export default (props: IClosingHeaderProps) => {
    const { headerText, className, label } = props;
    return (
        <HeaderContainer className="row">
            <div className={className}>
                <h2>{headerText.header} {headerText.subHeader} </h2>
                {label &&
                    <small>{label}</small>
                }
            </div>
        </HeaderContainer>
    );
};